function injectStyle (ssrContext) {
  require("!!../../../../cache/node/node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":true}!../../../../cache/node/node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-34acdde8\",\"scoped\":true,\"hasInlineConfig\":false}!sass-loader?{\"sourceMap\":true}!../../../../cache/node/node_modules/vue-loader/lib/selector?type=styles&index=0!./index.vue")
  require("!!../../../../cache/node/node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":true}!../../../../cache/node/node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-34acdde8\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../cache/node/node_modules/vue-loader/lib/selector?type=styles&index=1!./index.vue")
}
var normalizeComponent = require("!../../../../cache/node/node_modules/vue-loader/lib/component-normalizer")
/* script */
export * from "!!babel-loader!../../../../cache/node/node_modules/vue-loader/lib/selector?type=script&index=0!./index.vue"
import __vue_script__ from "!!babel-loader!../../../../cache/node/node_modules/vue-loader/lib/selector?type=script&index=0!./index.vue"
/* template */
import __vue_template__ from "!!../../../../cache/node/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-34acdde8\",\"hasScoped\":true,\"transformToRequire\":{\"video\":[\"src\",\"poster\"],\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"},\"buble\":{\"transforms\":{}}}!../../../../cache/node/node_modules/vue-loader/lib/selector?type=template&index=0!./index.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-34acdde8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/landingPage/index.vue
// module id = null
// module chunks = 